import Button from 'react-bootstrap/Button';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { useSelector } from 'react-redux';
import usePageNavigation from '../hooks/usePageNavigation';
import { isEmptyObject } from '../utils';

function ButtonBack({ pathName = '', classNames = { icon: '' }, styles = { top: '55px' } }) {
  const { selectedGuest } = useSelector((state) => state.guests);
  const {
    wayCaptureDocument,
    imageSide,
    imageFront,
    imageReverse,
  } = useSelector((state) => state.ocr);
  const { t } = useTranslation();

  const { nagivatePreviousPage } = usePageNavigation();

  const handleBtnBack = () => {
    let path = pathName.replaceAll('/', '');
    if (!isEmptyObject(selectedGuest)) {
      if (path === 'Residence' && ['2', '3'].includes(selectedGuest.TipoPersona)) {
        path = 'DocumentationReview';
      }
    }

    console.log(pathName, imageSide, imageFront, imageReverse)

    if (path === 'PrefixPreview') {
      if (wayCaptureDocument === 'byFile') {
        // if (imageSide === 'imageFront') {
          path = 'DocumentFront';
        // }

        // if (imageSide === 'imageReverse') {
        //   path = 'DocumentReverse';
        // }
      } else {
        if (imageSide === 'imageFront') {
          path = 'DocumentFrontCapture';
        }

        if (imageSide === 'imageReverse') {
          path = 'DocumentReverseCapture';
        }

        if (imageFront !== '' && imageReverse !== '') {
          path = 'DocumentFront';
        }
      }
    }

    nagivatePreviousPage(path);
  };

  return (
    <div className="position-absolute z-1" style={styles}>
      <Button
        variant=""
        onClick={() => handleBtnBack()}
      >
        <FontAwesomeIcon icon={faChevronLeft} className={`align-middle ${classNames.icon}`} />
        <span className={`ps-1 app-fs-14 ${classNames.span}`}>{t('TXT_BUTTON_BACK')}</span>
      </Button>
    </div>
  );
}

export default ButtonBack;
